// @core/api/endpoints/secret/encrypt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EncryptRequest,
  EncryptResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Encrypt data
 * Encrypts plaintext using the named key. Plaintext must be base64-encoded. Returns ciphertext in Vault format (vault:v{version}:base64). Supports batch encryption.
 */
export async function Encrypt(
  engine_id: string,
  key_name: string,
  data: EncryptRequest,
  options?: RequestOptions
): Promise<EncryptResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/encrypt/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<EncryptResponse>(requestPath, data, requestOptions);
}
